module.exports = __webpack_public_path__ + "static/retail_operational-981f6e13efbaaa609ea68de52febedcd.png";